import * as React from "react";
import { Link as ReactRouterLink } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";

import { MenuList } from "../../organisms/surveys/menu-list";
import { Breadcrumbs } from "@graffer-inc/console-design-kit";
import { BrowserTemplate } from "../base-template";
import { FeatureTitles } from "../../../application/domain/faeture-titles";
import { useAuthContext } from "../../../auth-state";
import { PlanError } from "../../organisms/common/plan-error";

interface SurveysTemplateProps {
  children: React.ReactNode;
  breadcrumbs: Array<{ to: string; title: string }>;
  menuLinkOverrideAction?: (path: string) => void;
}

export const SurveysTemplate: React.FC<SurveysTemplateProps> = ({
  breadcrumbs,
  children,
  menuLinkOverrideAction,
}) => {
  const authAcc = useAuthContext();
  return (
    <div id="rootWrapper">
      <BrowserTemplate title={FeatureTitles.Survey}>
        <div className="wrapper">
          {authAcc.isProductAvailable("Survey") ? (
            <div id="pageWrapper" className="columns" style={{ margin: 0 }}>
              <MenuList menuLinkOverrideAction={menuLinkOverrideAction} />
              <div className="column is-content-pane main">
                <Breadcrumbs
                  list={breadcrumbs}
                  anchor={({ href = "", ...props }) => (
                    <ReactRouterLink
                      {...props}
                      to={href}
                      onClick={
                        menuLinkOverrideAction
                          ? (e: React.MouseEvent<HTMLAnchorElement>) => {
                              e.preventDefault();
                              menuLinkOverrideAction(href);
                            }
                          : undefined
                      }
                    />
                  )}
                />
                {children}
              </div>
            </div>
          ) : (
            <PlanError title={FeatureTitles.Survey} />
          )}
        </div>
      </BrowserTemplate>
    </div>
  );
};
